import React from "react";
import Button from "components/atoms/button/index.jsx";
import FormActions from "components/molecules/formActions/index.jsx";

import buyIcon from "resources/img/buy-icon.svg";
import "containers/buy/styles.scss";

export default class StartForm extends React.Component {
  render() {
    const vehicle = this.props.vehicle;

    return (
      <div>
        <div className="formText">
          <div className="iconCol">
            <img src={buyIcon} alt="Reserva" />
          </div>
          <div className="textCol">
            <p className="m">
              Estas por reservar un{" "}
              <strong>
                {vehicle.brand} {vehicle.name}
              </strong>
              . Es muy simple:
              <br />
              Te solicitaremos tus datos personales de contacto y la reserva se
              hará efectiva con una seña de $50.000 que pagas con tu tarjeta de
              crédito.
            </p>
            <p className="m">
              Una vez abonada la seña, tenés 48 horas para revisar y concretar
              la operación, y{" "}
              <strong>
                de no estar satisfecho se te reintegra el 100% del dinero
              </strong>
              .
            </p>
          </div>
        </div>

        <FormActions>
          <Button
            buttonText="Reservar este auto"
            onClick={this.props.onSubmit}
          />
        </FormActions>
      </div>
    );
  }
}
